import { trackingConstants as constants } from '../../constants/tracking'

const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedData: null,
  isError: null,
  error: ''
}

const trackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL:
      return { ...state, isError: null, allData: action.data}
    case constants.GET_DATA:
      return {
        ...state,
        isError: null,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case constants.GET_SELECT:
      return { ...state, isError: null, selectedData: action.selectedData }

    case constants.INSERT_SUCCESS:
      return { ...state, isError: false, error: '' }

    case constants.GET_FAILURE:
    case constants.INSERT_FAILURE:
        return { ...state, isError: true, error: action.error}

    case constants.CLEAR_DATA:
      return { ...state, isError: null, error: '', selectedData: null  }
      
    default:
      return { ...state }
  }
}
export default trackingReducer
